<template>
  <div id="app" class="login-wrapper fixed w-screen h-screen flex">
    <div class="hidden md:inline-block w-4/6" :style="bg"></div>
    <div class="flex flex-col p-4 md:p-16 w-full md:w-2/6 items-start">
      <h1 class="display-1 text-4xl font-hairline mb-16">Bellman</h1>
      <router-view/>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'App',
  computed: {
    bg () {
      return {
        'background-image': 'url(https://owlpos-assets.s3-eu-west-1.amazonaws.com/images/food-background-full.png)',
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center'
      }
    },
  },
  beforeMount () {
    Cookies.remove('token', {domain: process.env.VUE_APP_COOKIE_DOMAIN})
    Cookies.remove('role', {domain: process.env.VUE_APP_COOKIE_DOMAIN})
    /*
    if (Cookies.get('token') && Cookies.get('role')) {
      var role = parseInt(Cookies.get('role'))
      if (role === 1) {
        window.location.href = process.env.VUE_APP_URL_ADMIN
      } else if (role === 2) {
        window.location.href = process.env.VUE_APP_URL_MANAGER
      } else if (role === 3) {
        window.location.href = process.env.VUE_APP_URL_EMPLOYEE
      } else if (role === 4) {
        window.location.href = process.env.VUE_APP_URL_STAFF
      } else if (role === 5) {
        window.location.href = process.env.VUE_APP_URL_CASHIER
      }
    } else {
      Cookies.remove('token', {domain: process.env.COOKIE_DOMAIN})
      Cookies.remove('role', {domain: process.env.COOKIE_DOMAIN})
    }
    */
  }
}
</script>
